import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2370d386"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "suggestion__description" }, "Suggestions", -1))
const _hoisted_3 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.hasTag)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.limitedTags, (tag) => {
          return (_openBlock(), _createElementBlock("button", {
            key: tag.name,
            type: "button",
            class: "m-tag m-tag_secondary suggestion__tag",
            onClick: ($event: any) => (_ctx.selectSkill(tag))
          }, _toDisplayString(tag.name), 9, _hoisted_3))
        }), 128))
      ]))
    : _createCommentVNode("", true)
}